import {Pipe, PipeTransform} from "@angular/core";
import {Scope} from "../../../../store/state/order.state";

@Pipe({
    name: 'scopeToString',
    standalone: false
})
export class ScopeToStringPipe implements PipeTransform {

	transform(scope: Scope): any {
		return `${scope.code} - ${scope.name}`.toUpperCase();
	}
}
